export function isMobileDevice(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  const hasTouch =
    (typeof window !== 'undefined' && 'ontouchstart' in window) || navigator.maxTouchPoints > 0;
  return hasTouch && /Mobi|Android|iPhone|iPad|iPod/i.test(ua);
}
